module.exports = __webpack_public_path__ + "media/media/logos/mfpt-42cecd272867d45f8ab8574cf18dd33b.png";